import axiosInstance from 'services/axiosMiddleware';

export const importSpecificAsanaFromLibrary = async ({ asanaId, libraryAsanaId, courseId }) => {
  const { data } = await axiosInstance.post('library/importSpecificAsanaFromLibrary', {
    asanaId,
    libraryAsanaId,
    courseId
  });
  return data;
};
